import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
// styles
import { DialogStyled } from "./styles";
export var Dialog = function (_a) {
    var children = _a.children, onClose = _a.onClose, _b = _a.isVisible, isVisible = _b === void 0 ? false : _b, _c = _a.isModal, isModal = _c === void 0 ? true : _c, _d = _a.isFullScreen, isFullScreen = _d === void 0 ? false : _d, _e = _a.width, width = _e === void 0 ? "500px" : _e, height = _a.height, zIndex = _a.zIndex, // only needed when isModal = false
    className = _a.className;
    var dialogRef = useRef(null);
    // Handle showing/hiding the modal using native dialog API
    useEffect(function () {
        var dialog = dialogRef.current;
        if (!dialog)
            return;
        // Polyfill for jsdom/test environments that don't support showModal
        if (typeof dialog.showModal !== "function") {
            dialog.showModal = function () {
                this.open = true;
            };
            dialog.show = function () {
                this.open = true;
            };
        }
        if (typeof dialog.close !== "function") {
            dialog.close = function () {
                this.open = false;
            };
        }
        if (isVisible && !dialog.open) {
            if (isModal) {
                dialog.showModal();
            }
            else {
                dialog.show();
            }
        }
        else if (!isVisible && dialog.open) {
            dialog.close();
        }
    }, [isVisible]);
    // Handle ESC key and backdrop click
    useEffect(function () {
        var dialog = dialogRef.current;
        if (!dialog)
            return;
        var handleCancel = function (e) {
            // Prevent default ESC behavior, let our handler manage it
            e.preventDefault();
            onClose === null || onClose === void 0 ? void 0 : onClose();
        };
        // Handle backdrop click
        var handleClick = function (e) {
            // for non-modal dialog, we don't want to close on outside click
            if (!isModal)
                return;
            var rect = dialog.getBoundingClientRect();
            var isInDialog = rect.top <= e.clientY &&
                e.clientY <= rect.top + rect.height &&
                rect.left <= e.clientX &&
                e.clientX <= rect.left + rect.width;
            if (!isInDialog) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        };
        dialog.addEventListener("cancel", handleCancel);
        dialog.addEventListener("click", handleClick);
        return function () {
            dialog.removeEventListener("cancel", handleCancel);
            dialog.removeEventListener("click", handleClick);
        };
    }, [onClose]);
    // Don't render the dialog in the DOM until it's needed
    if (!isVisible) {
        return null;
    }
    return (_jsx(DialogStyled, { ref: dialogRef, isFullScreen: isFullScreen, "$width": width, "$height": height, zIndex: zIndex, className: className, children: children }));
};
export default Dialog;
